import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    activityId: null,
    documentId: null,
    courseId: null,
    linkCardData: [
      {
        category: "Biology",
        color: "#e3f2e7",
        links: [
          {
            title: "VIRTUAL MICROSCOPE",
            thumbnailLink: "microscope.png",
            link: "https://students.open.ac.uk/candc/open_stem_africa/virtual_microscope/",
            dsc: "Examine the structure of plant and animal cells",
            maintnance: false,
            update: false,
            prototype: false
          },
          {
            title: "SPIROMETER",
            thumbnailLink: "spirometer.png",
            link: "https://students.open.ac.uk/candc/open_stem_africa/spirometer/",
            dsc: "Investigate how lung function changes with age, height and gender",
            maintnance: false,
            update: false,
            prototype: false
          },
          {
            title: "HUMAN HEART",
            thumbnailLink: "heart.png",
            link: "https://www.open.edu/openlearncreate/pluginfile.php/651393/mod_resource/content/3/index.html",
            dsc: "Explore the beating of a human heart",
            maintnance: false,
            update: false,
            prototype: false
          },
          {
            title: "VIRTUAL FIELD TRIP",
            thumbnailLink: "virtual_field_trip.png",
            link: "https://students.open.ac.uk/candc/open_stem_africa/virtual_field_trip/",
            dsc: "Use observational and scientific methods to explore different habitats",
            maintnance: false,
            update: false,
            prototype: false
          },
          {
            title: "FOOD TESTS",
            thumbnailLink: "food_tests.png",
            link: "",
            dsc: "Detect the presence of major nutrients in food",
            maintnance: true,
            update: false,
            prototype: false
          }
        ]
      }
    ]
  },
  mutations: {
    SET_ACTIVITY_ID(state, payload) {
      state.activityId = payload;
    },
    SET_DOCUMENT_ID(state, payload) {
      state.documentId = payload;
    },
    SET_COURSE_ID(state, payload) {
      state.courseId = payload;
    }
  },
  actions: {
    setActivityId({
      commit
    }, payload) {
      commit("SET_ACTIVITY_ID", payload);
    },
    setDocumentId({
      commit
    }, payload) {
      commit("SET_DOCUMENT_ID", payload);
    },
    setCourseId({
      commit
    }, payload) {
      commit("SET_COURSE_ID", payload);
    }
  }
});